module.exports = __webpack_public_path__ + "static/media/28_B.44845c2b.png";